import { Link } from "react-router-dom";
import { MessageCircle, CheckCircle2, CreditCard, Database, Webhook } from "lucide-react";
import PageHeader from "@/components/crud/PageHeader";

const INTEGRACOES = [
  { nome: "WhatsApp · Z-API", desc: "Conexão do WhatsApp, campanhas, cupons e mensagens automáticas via Z-API.", icon: MessageCircle, ativa: true, link: "/master/whatsapp?tab=status", cta: "Conectar WhatsApp →" },
  { nome: "Webhook de eventos", desc: "Notificações de atendimentos e prêmios para sistemas externos.", icon: Webhook, ativa: false },
  { nome: "Gateway de pagamento", desc: "Cobrança e conciliação financeira integradas à plataforma.", icon: CreditCard, ativa: false },
  { nome: "ERP / Retaguarda", desc: "Sincronização de cadastros e vendas com a retaguarda.", icon: Database, ativa: false },
];

export default function MasterIntegracoes() {
  return (
    <div className="px-4 md:px-6 pt-4 pb-8 space-y-4 float-in" data-testid="master-integracoes">
      <PageHeader chip="Sistema" title="Integrações" subtitle="Conexões da plataforma com serviços externos." />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {INTEGRACOES.map((it) => {
          const Icon = it.icon;
          return (
            <div key={it.nome} className="card-soft rounded-xl p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div className="w-11 h-11 rounded-lg flex items-center justify-center"
                     style={{ background: it.ativa ? "rgba(16,185,129,0.12)" : "rgba(15,23,42,0.06)" }}>
                  <Icon size={20} className={it.ativa ? "text-emerald-600" : "text-neutral-400"} />
                </div>
                {it.ativa
                  ? <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-emerald-700"><CheckCircle2 size={12} /> Ativa</span>
                  : <span className="text-[10px] font-bold uppercase tracking-wide text-neutral-400">Em breve</span>}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-[15px] text-[color:var(--ink)]">{it.nome}</div>
                <div className="text-[12px] text-neutral-500 mt-0.5 leading-snug">{it.desc}</div>
              </div>
              {it.link && (
                <Link to={it.link} className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-[color:var(--brand-blue)] hover:underline">
                  {it.cta || "Configurar →"}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
